import React from "react";
import { withRouter } from "react-router-dom";
import classnames from "classnames";
import Logo from "../images/logo-dark.svg";
import GoToTop from "../GoToTop";
import Button from "../components/Button";
import { MenuLinks } from "./utils";
import { Link } from "react-scroll";
import { tockSearchUrl } from "../utils/tock";

class Navigation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showMenu: false,
      scrollLock: false,
      showWineTypes: false,
    };
    this.wrapperRef = React.createRef();
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }
  closeMenu = () => {
    this.setState({
      showMenu: false,
    });
  };

  setBodyScrollLock = (locked) => {
    document.body.style.overflow = locked ? "hidden" : "";
  };

  componentDidMount() {
    document.addEventListener("mouseup", this.handleClickOutside);
  }

  componentDidUpdate(_prevProps, prevState) {
    if (prevState.showMenu !== this.state.showMenu) {
      this.setBodyScrollLock(this.state.showMenu);
    }
  }

  componentWillUnmount() {
    document.removeEventListener("mouseup", this.handleClickOutside);
    this.setBodyScrollLock(false);
  }
  handleClickOutside(event) {
    if (this.state.showMenu) {
      if (
        this.wrapperRef.current &&
        !this.wrapperRef.current.contains(event.target)
      ) {
        this.setState({ showMenu: false });
      }
    }
  }

  renderMainNav = (currentPage) => {
    return (
      <nav
        ref={this.wrapperRef}
        className={classnames("menu", {
          "show-menu": this.state.showMenu,
        })}
      >
        <div className="menu-content">
          <img
            src={Logo}
            onClick={() => this.props.history.push("/")}
            className="logo m-t-50"
            alt="logo"
          ></img>
          <Button
            className="width-150"
            external
            onClick={() =>
              (window.location.href =
                "https://auburnroadvineyards.orderport.net/wines/Available-Wines")
            }
            type="secondary"
          >
            Buy Online
          </Button>
          <Button
            className="link main-menu-item justify-content-start p-0 m-t-40"
            external
            href={tockSearchUrl()}
          >
            Reservations
          </Button>
          <MenuLinks
            currentPage={currentPage}
            toggleContactOverlayFn={this.props.toggleContactOverlay}
            closeMenu={this.closeMenu}
          />
        </div>
      </nav>
    );
  };

  renderLocalNav = () => {
    const links = [
      { id: "wine", label: "Wine" },
      { id: "starters", label: "Starters" },
      { id: "soup-salad", label: "Soup & salad" },
      { id: "piadine", label: "Piadine" },
      { id: "pizza", label: "Pizza" },
      { id: "dessert", label: "Dessert" },
      { id: "drinks", label: "Drinks" },
    ];
    const wineLinks = [
      "white",
      "sweet",
      "sparkling",
      "red",
      "fortified",
      "cellar",
    ];
    const scrollOffset = -100;
    const prefersReduced =
      typeof window !== "undefined" &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const scrollDuration = prefersReduced ? 0 : 450;

    return (
      <nav
        ref={this.wrapperRef}
        className={classnames("menu menu--local", {
          "show-menu": this.state.showMenu,
        })}
        aria-label="Menu sections"
      >
        <div className="menu-content">
          <img src={Logo} className="logo logo--static m-t-50" alt="logo" />
          {links.map((link) => {
            if (link.id === "wine") {
              return (
                <React.Fragment key={link.id}>
                  <button
                    type="button"
                    className={classnames("local-menu-item", {
                      open: this.state.showWineTypes,
                    })}
                    aria-expanded={this.state.showWineTypes}
                    onClick={() =>
                      this.setState({
                        showWineTypes: !this.state.showWineTypes,
                      })
                    }
                  >
                    {link.label}
                  </button>
                  <div
                    className={classnames("local-menu-subitem-wrap", {
                      show: this.state.showWineTypes,
                    })}
                  >
                    {wineLinks.map((type) => (
                      <Link
                        key={type}
                        onClick={this.closeMenu}
                        className="local-menu-subitem"
                        activeClass="active"
                        to={type}
                        spy={true}
                        smooth={!prefersReduced}
                        offset={scrollOffset}
                        duration={scrollDuration}
                      >
                        {type}
                      </Link>
                    ))}
                  </div>
                </React.Fragment>
              );
            }
            return (
              <Link
                key={link.id}
                onClick={this.closeMenu}
                className="local-menu-item"
                activeClass="active"
                to={link.id}
                spy={true}
                smooth={!prefersReduced}
                offset={scrollOffset}
                duration={scrollDuration}
              >
                {link.label}
              </Link>
            );
          })}
        </div>
      </nav>
    );
  };

  render() {
    const currentPage = this.props.history.location.pathname;

    return (
      <>
        <GoToTop />
        <div ref={this.wrapperRef}>
          {!this.state.showMenu ? (
            <div
              onClick={() => {
                this.setState({ showMenu: true });
              }}
              className="nav-icon nav-open-icon"
            ></div>
          ) : (
            <div
              onClick={() => {
                this.setState({ showMenu: false });
              }}
              className="nav-icon nav-close-icon"
            ></div>
          )}
          {currentPage === "/menu-local"
            ? this.renderLocalNav(currentPage)
            : this.renderMainNav()}
        </div>
      </>
    );
  }
}

export default withRouter(Navigation);
